var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnership-information-container"
  }, [_c('div', {
    staticClass: "partnership-settings-container"
  }, [_c('div', {
    staticClass: "partnership-settings"
  }, [_c('div', {
    staticClass: "sharing-partner-data"
  }, [_c('partnership-view-data', {
    attrs: {
      "label": _vm.$t('common.invite'),
      "description": _vm.inviteLink
    },
    on: {
      "click": _vm.onCopy
    }
  }), _c('div', {
    staticClass: "repost-social-button",
    on: {
      "click": _vm.onShownSharingDialog
    }
  })], 1), !_vm.isMobile ? _c('div', {
    staticClass: "report-button",
    class: {
      disabled: _vm.isEmptyParnterList
    },
    on: {
      "click": _vm.handleClickToReport
    }
  }, [_c('span', {
    staticClass: "report-download-icon"
  }), _vm._v(" " + _vm._s(_vm.$t('common.report')) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "partnership-settings"
  }, [_c('div', {
    staticClass: "partnership-deductions"
  }, [_c('partnership-view-data', {
    attrs: {
      "label": _vm.$t('contributions.to'),
      "icon": "settings",
      "description": _vm.partner && _vm.partner.parentProjectName ? _vm.partner.parentProjectName : ''
    },
    on: {
      "click": _vm.onShownChangeProject
    }
  })], 1), _vm.isShownRateButtonByDesktop ? _c('div', {
    staticClass: "rate-control-button",
    class: {
      active: _vm.partner.rateChangePermission
    },
    on: {
      "click": _vm.onShownChangePartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.displayPartnerRate) + " ")]) : _vm._e()]), _vm.isShownRateButtonByMobile ? _c('div', {
    staticClass: "partnership-settings"
  }, [_c('div', {
    staticClass: "rate-control-button",
    class: {
      active: _vm.partner.rateChangePermission
    },
    on: {
      "click": _vm.onShownChangePartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.displayPartnerRate) + " ")])]) : _vm._e(), _vm.isMobile ? _c('div', {
    staticClass: "partnership-settings"
  }, [_c('div', {
    staticClass: "report-button",
    class: {
      disabled: _vm.isEmptyParnterList
    },
    on: {
      "click": _vm.handleClickToReport
    }
  }, [_c('span', {
    staticClass: "report-download-icon"
  }), _vm._v(" " + _vm._s(_vm.$t('common.report')) + " ")])]) : _vm._e()]), _c('cs-dialog', {
    model: {
      value: _vm.isShownSocialSharing,
      callback: function callback($$v) {
        _vm.isShownSocialSharing = $$v;
      },
      expression: "isShownSocialSharing"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('share.on.social.media')))]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "social-share-conatiner"
  }, [_c('socials-share', {
    attrs: {
      "url": _vm.partner.link,
      "title": "".concat(_vm.$t('referral.link'), " | capusta.space"),
      "description": _vm.partner.parentProjectName
    }
  })], 1)])])], 1), _c('div', {
    ref: "mainContainer"
  }, [_c('cs-dialog', {
    model: {
      value: _vm.isShownChangeProject,
      callback: function callback($$v) {
        _vm.isShownChangeProject = $$v;
      },
      expression: "isShownChangeProject"
    }
  }, [_c('dialog-list-layout', {
    on: {
      "scroll-end": function scrollEnd($event) {
        return _vm.$emit('load-next');
      }
    }
  }, _vm._l(_vm.preparedProjectList, function (project) {
    return _c('capusta-option-panel', {
      key: project.id,
      attrs: {
        "option": project
      },
      on: {
        "click": _vm.onShownConfirmChangeProject
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(props) {
          return _c('div', {
            staticClass: "option-container"
          }, [_c('project-logo', {
            attrs: {
              "project": props.option
            }
          }), _c('section', [_c('p', [_vm._v(_vm._s(props.option.description))]), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t(props.option.label)))])])])], 1);
        }
      }], null, true)
    });
  }), 1)], 1)], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownConfirmChangeProject,
      callback: function callback($$v) {
        _vm.isShownConfirmChangeProject = $$v;
      },
      expression: "isShownConfirmChangeProject"
    }
  }, [_c('dialog-default-layout', [_c('div', {
    staticClass: "dialog-layout-confirmation",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('you.want.change.project.for.deductions.on', {
    projectName: _vm.selectedProjectName
  })))])]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 190
    },
    on: {
      "click": _vm.onChangeProject
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')) + " ")]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseConfirmChangeProject
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownChangePartnerRate,
      callback: function callback($$v) {
        _vm.isShownChangePartnerRate = $$v;
      },
      expression: "isShownChangePartnerRate"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    staticClass: "dialog-layout-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('enter.rate')) + " "), _c('a', {
    attrs: {
      "href": "https://help.capusta.space/partner/rate",
      "target": "_blank"
    }
  })]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "dialog-layout-text"
  }, [_vm._v(_vm._s(_vm.displayMaxAvailableRate))]), _c('div', {
    staticClass: "dialog-layout-input"
  }, [_c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.percentTokens,
      expression: "percentTokens"
    }],
    attrs: {
      "error": !_vm.isValidPartnerRate,
      "validation": _vm.validatePartnerRate,
      "label": "".concat(_vm.$t('common.percent'), ", %"),
      "placeholder": "0.5"
    },
    model: {
      value: _vm.partnerRate,
      callback: function callback($$v) {
        _vm.partnerRate = $$v;
      },
      expression: "partnerRate"
    }
  })], 1)]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 200,
      "disabled": !_vm.isValidPartnerRate
    },
    on: {
      "click": _vm.onShownConfirmPartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseChangePartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 2)], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownConfirmPartnerRate,
      callback: function callback($$v) {
        _vm.isShownConfirmPartnerRate = $$v;
      },
      expression: "isShownConfirmPartnerRate"
    }
  }, [_c('dialog-default-layout', [_c('div', {
    staticClass: "dialog-layout-confirmation",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('you.want.change.rate.for.all.partners')))])]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": 190
    },
    on: {
      "click": _vm.onChangePartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')) + " ")]), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": _vm.onCloseChangePartnerRate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }